class CBm {
	constructor() {}
}

module.exports = CBm;



// WEBPACK FOOTER //
// ./temp/components/bm/index.js